import React, { useEffect, useState } from "react";
import monkey from "../../monkey1.gif"
import monkeyClick from "../../monkeyClick.gif";
import monkeyLeaving from "../../monkeyLeaving.gif";

/**
 * Monkey animation
 * 
 * Animation contains 3 gifs 
 * (monkey, monkeyClick, monkeyLeaving) 
 * the active one is changes on certain 
 * events. Such as click, end of animation.
 * 
 * used: private/hw dashboards
 * 
 * @param {props} show  
 * @param {props} setShow 
 * 
 * @returns gif 
 */
const AnimatedSprite = ({show, setShow}) => {

    const [xPos, setXPos] = useState(1); // initial x position
    const [activeSprite, setActiveSprite] = useState(monkey); // initial active sprite / animation

    // * Effects

    // initial effect when show is true
    useEffect(() => {
        if (show) {
            // set initial position
            const initialX = Math.random() * 70;
            setXPos(initialX < 5 ? 5 : initialX);
        }
    }, [show])

    
    // effect on activeSprite change
    useEffect(() => {
        // when changed to monkey animation
        if (activeSprite === monkey) {
            // after 8 seconds change to leaving animation
            const switchToLeaving = setTimeout(() => {
                setActiveSprite(monkeyLeaving);
            }, 8000);

            // after 5 seconds start increasing x (moving monkey)
            const startIncrease = setTimeout(() => {
                const intervalId = setInterval(() => {
                    setXPos(prevXPos => prevXPos + 2);
                }, 100);
                
                // stop increase clear timeout
                const stopIncrease = setTimeout(() => {
                    clearInterval(intervalId);
                }, 1000);
            }, 5800);

            // clear timeouts
            return () => {
                clearTimeout(switchToLeaving);
                clearTimeout(startIncrease);
            };
        }

        // when changed to monkey leaving animation
        if (activeSprite === monkeyLeaving) {
            // end all animations after 10 seconds
            const leavingAnimation = setTimeout(() => {
                setShow(false);
            }, 10000);
            
            // clear timeout
            return () => {
                clearTimeout(leavingAnimation);
            }
        }
    }, [activeSprite])


    // * Handlers

    // when monkey is clicked
    const animationClicked = () => {
        // change animation to monkey clicked
        setActiveSprite(monkeyClick);
        
        // switch to monkey animation after 3 seconds
        const switchBack = setTimeout(() => {
            setActiveSprite(monkey);
        }, 3000);

        // clear timeout
        return () => {
            clearTimeout(switchBack);
        }
    }


    // * GUI
    return (
        <>
        <div
            hidden={!show}
            style={{
                position: "absolute",
                left: `${xPos}%`,
                top: 80,
                zIndex: 0,
            }}
            onClick={() => animationClicked()}
        >
            <img src={activeSprite} alt="animate" />
        </div>
        </>
    )
}
export default AnimatedSprite;